import { InlineFlexPropsType } from "components/basic/flex/style"

export const menuStyle: InlineFlexPropsType = {
    position: "fixed",
    fDirection: "column",
    top: "50%",
    left: "1rem",
    transform: "translateY(-50%)",
    zIndex: "9999",
    gap: ".65rem"
}

export const flexStyle = {
    w: ".3rem",
    h: ".3rem",
    background: "white",
    radius: "10rem"
}